import BaseCounter from "@PegasusCore/pegasus-one-counter/src/script";

class Counter extends BaseCounter {
    startCount(thousands = 'comma', decimal = 'period') {
        const step = (currentTime) => {
            if (!this.startTime) {
                this.startTime = currentTime;
            }

            const progress = Math.min((currentTime - this.startTime) / 1500, 1);

            let targetNumber = parseFloat(this.$refs.number.dataset.counterNumber);
            let countedValue = progress * targetNumber;
            let formattedNumber;

            if (progress < 1) {
                if (targetNumber < 10) {
                    formattedNumber = this.separateDecimals(countedValue.toFixed(2), decimal);
                } else if ((targetNumber - Math.floor(targetNumber)) !== 0) {
                    formattedNumber = this.separateDecimals(countedValue.toFixed(1), decimal);
                } else {
                    formattedNumber = Math.floor(countedValue).toString();
                }
            } else {
                formattedNumber = this.separateThousands(
                    (targetNumber % 1 === 0)
                        ? targetNumber.toString()
                        : this.separateDecimals(targetNumber.toString(), decimal),
                    thousands
                );
                this.$refs.number.innerHTML = formattedNumber;
                return;
            }

            this.$refs.number.innerHTML = this.separateThousands(formattedNumber, thousands);
            window.requestAnimationFrame(step);
        };

        window.requestAnimationFrame(step);
    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('counter', () => new Counter());
});
